<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import i18n from '@/localization/i18n';
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { navigate } from 'vike/client/router';
import { logNewEvent } from '@/services/modules/firebase';

const businessRequestFormStore = useBusinessRequestFormStore()

const t = i18n.global.t

const setTimeoutId = ref<any | null>(null)

onMounted(() => {
  setTimeoutId.value = setTimeout(() => {
    handleCloseAndRedirect()
  }, 8000)
})

const handleCloseAndRedirect =async () =>{
    const dismissButton: any = document.querySelector('#dismissRequestPostModal')
    if(dismissButton) dismissButton?.click()
    businessRequestFormStore.fromModal = true

    logNewEvent("presta_request_submited")

    businessRequestFormStore.clearFormsData()
    await navigate('/cs/home/')
}

onBeforeUnmount(() => {
  if (setTimeoutId.value !== null) clearTimeout(setTimeoutId.value);
  setTimeoutId.value = null;
});
</script>

<template>
    <div class="bg rounded main fullHeight" style="height: 550px">
        <div class="fullHeight content mt">
            <div class="block-spacing padding" >
                <div>
                    <p class="white-text">
                        {{ t("w_txt_business_request_verification_delay") }}
                    </p>
                </div>
                <div class="" style="margin-top: 30px;">
                    <p class="white-text">
                        {{ t("w_txt_business_request_info_remain_confidential") }} <br>
                        {{ t("w_txt_business_request_notified_when_interrested") }}
                    </p>
                </div>
                <div>
                    <div class="h-style h2-style use-poppins three-dot" style="margin-top: 40px;">
                        <span>.</span>
                        <span>.</span>
                        <span>.</span>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>
.main {
    padding: 15px;
    position: relative;
}

.bg {
    background-color: #FEB23C !important;
}

.fullHeight {
    height: 100%;
    z-index: 1px;
    display: flex;
    align-items: center; 
    justify-content: center;
    flex-direction: column;
    border: none !important;
}

.mt {
    margin-top: 10px;
}

.white-text {
    color: rgb(243, 232, 232);
    font-size: 19px;
}

.three-dot {
    color: white;
}

.padding{
    margin-left: 10px;
    margin-right: 10px;
}

.three-dot span {
  font-size: 28px !important; 
  margin: 0 5px;
  animation: blink 1.5s infinite;
}

.three-dot span:nth-child(1) {
  animation-delay: 0s;
}

.three-dot span:nth-child(2) {
  animation-delay: 0.2s;
}

.three-dot span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 20% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
    /* Styles for medium screens */
    .padding{
        margin-left: 80px !important;
        margin-right: 80px !important;
    }
}

</style>